import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=bee4f1a2&"
import script from "./AppButton.vue?vue&type=script&lang=js&"
export * from "./AppButton.vue?vue&type=script&lang=js&"
import style0 from "./AppButton.vue?vue&type=style&index=0&id=bee4f1a2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports